import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useQuestionAwnserDispatch, } from "./question-awnser-context";
import { IListQuestionAnwserRequest } from "../../../model/base/request/list-question-anwser-request";

export const useQuestionAwnserController = () => {
    const QuestionAwnserDispatch = useQuestionAwnserDispatch();
    async function loadData(request: IListQuestionAnwserRequest) {
        try {
            const result = await PortalAppService.listQuestionAwnser(request);
            QuestionAwnserDispatch({
                type: ACTION_TYPES.loadingData,
                payload: result,
            });

            const categories = await BaseAppService.getListCategporyQuestionAnswer();

            QuestionAwnserDispatch({
                type: ACTION_TYPES.setCategories,
                payload: categories,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        loadData
    };
}


